import DataFetcherTemplate from "../../hooks/fetchTemplate";
import BannerGeneral from "../../components/BannerGeneral";
import ModalFixed from "../../components/ModalFixed";
import BlockBackgroundImage from "../../components/BlockBackgroundImage";
import BlockImageCabecera from "../../components/BlockImageCabecera";

import Breadcumbs from "../../components/Breadcumbs";
import { NavLink } from "react-router-dom";

import ConectUs from "../../components/ConectUs";

import ImageGallery from "../../components/ImageGallery";
import { PosgradoPostulacionFixed } from "../../components/Pasos";
import Modal from "../../components/Modal";

import OfferPresencial from "../../components/view/OfferPresencial";
import PresencialPagos from "../../components/PresencialPagos";
import BlockRightImage from "../../components/BlockRightImage";
import BlockLeftImage from "../../components/BlockLeftImage";

function Presencial() {
  const DataDisplay = ({ data }) => (
    <>
      <div>
        {data.map((item, index) => (
          <div>
            {" "}
            <div className="relative">
              <BlockImageCabecera
                src={item.field_portada}
                title={
                  <>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.field_texto_portada,
                      }}
                    />
                  </>
                }
              ></BlockImageCabecera>

              {/*   <ModalFixed
                color="#00bcd4"
                title="Conoce los pasos para inscribirte a la prueba 💙🐆"
                content={
                  <>
                    <iframe
                      width="100%"
                      height="400"
                      src="https://www.youtube.com/embed/u-v0tQFxWa0?si=_o-iZN8h_44JqCyy"
                      frameborder="0"
                      allowfullscreen
                    ></iframe>
                  </>
                }
              >
                {" "}
              </ModalFixed> */}
            </div>{" "}
            <Breadcumbs
              content={
                <>
                  <NavLink to="/presencial">Modalidad Presencial</NavLink>
                </>
              }
            ></Breadcumbs>
            <div
              className="layout6"
              dangerouslySetInnerHTML={{
                __html: item.field_bloque1,
              }}
            />
            <section>
              <div className="w-full max-w-6xl mx-auto px-4 pt-12 pb-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  {/* Columna 1: Prueba Diagnóstica */}
                  <div className="bg-blue-50/50 border border-blue-100 rounded-2xl p-6 md:p-8 flex flex-col justify-between shadow-sm transition-all hover:shadow-md">
                    <div>
                      <div className="inline-block bg-gray-200 text-[#004270] text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full mb-4">
                        Convocatoria abierta
                      </div>
                      <h3  className="font-bold">
                        Carreras con prueba diagnóstica
                      </h3>

                      <div className="space-y-3 text-gray-700 mb-6">
                        <p className="flex flex-col sm:flex-row sm:items-center gap-1">
                          <span className="font-semibold text-gray-900">
                            Inscripción y matrícula:
                          </span>
                          <span>del 18 de febrero al 25 de septiembre</span>
                        </p>

                        <p className="flex flex-col sm:flex-row sm:items-center gap-1">
                          <span className="font-semibold text-gray-900">
                            Inicio de clases:
                          </span>
                          <span>5 de octubre de 2026</span>
                        </p>
                      </div>
                    </div>

                    <a
                      href="https://utpl.edu.ec/documentos/manual_presencial.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center w-full sm:w-auto bg-green-100 text-green-700 hover:bg-green-800  hover:text-white font-medium text-sm py-3 px-5 rounded-xl transition-colors mt-4 text-center"
                    >
                      Descargar manual de postulación
                      <svg
                        className="w-4 h-4 ml-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                        />
                      </svg>
                    </a>
                  </div>

                  {/* Columna 2: Prueba de Admisión */}
                  <div className="bg-gray-50 border border-gray-200 rounded-2xl p-6 md:p-8 flex flex-col justify-between shadow-sm opacity-95">
                    <div>
                      <div className="inline-block bg-gray-200 text-[#004270] text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full mb-4">
                        Convocatoria Cerrada
                      </div>
                          <h3  className="font-bold">
                        Carreras con prueba de admisión
                      </h3>

                      <p className="flex flex-col sm:flex-row sm:items-center gap-1">
                      <b> 
                          Inicio de clases (medicina):</b> 28 de septiembre de 2026 
                      </p>

                      <p className="flex flex-col sm:flex-row sm:items-center gap-1">
                       
                        <b>  Inicio de clases (demás carreras):</b>
                      
                        <span>5 de octubre de 2026</span>
                      </p>
                    </div>

                    <div>
                      <div className="inline-block bg-gray-200 mt-6 text-[#004270] text-xs font-semibold uppercase tracking-wider px-3 py-1 rounded-full mb-4">
                       Convocatoria Abierta{" "}
                      </div>

                      <p><b>Segunda convocatoria:</b> Arquitectura e Ingeniería Civil</p>
  <p><b>Periodo de inscripciones: </b>hasta el 28 de julio de 2026.</p>
  <p><b>Aplicación de la prueba de admisión:</b> 4 de agosto de 2026</p>
                    </div>

                    <a
                      href="https://utpl.edu.ec/horarios-prueba-admision"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center justify-center w-full sm:w-auto  hover:bg-red-700 hover:text-white bg-red-100 text-red-700 font-medium text-sm py-3 px-5 rounded-xl transition-colors mt-4 text-center"
                    >
                      Consultar horario de prueba
                      <svg
                        className="w-4 h-4 ml-2"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </section>
            <div className="margin">
              <OfferPresencial></OfferPresencial>
            </div>
            {/*   <div className="padding">
              <PresencialPagos></PresencialPagos>
            </div> */}
            <div className="margin">
              <div className="relative">
                <BlockLeftImage
                  src={item.field_imagen2}
                  content={
                    <>
                      {" "}
                      <div
                        dangerouslySetInnerHTML={{
                          __html: item.field_bloque2,
                        }}
                      />
                      <Modal
                        color="#6d46ce"
                        id="tematicas"
                        title="Consulta las temáticas de la prueba 📘"
                        content={
                          <>
                            <img src={item.field_imagen4} alt="utpl"></img>
                          </>
                        }
                      ></Modal>
                    </>
                  }
                ></BlockLeftImage>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <>
      <DataFetcherTemplate url="https://utpl.edu.ec/carreras/oferta/servicio-presencial.json">
        {(data) => <DataDisplay data={data} />}
      </DataFetcherTemplate>
      <div className="padding2">
        <ConectUs
          lema="Descubre contenido exclusivo, mantente al tanto de las últimas novedades y únete a nuestra comunidad de estudiantes presenciales."
          facebook="https://www.facebook.com/utplpresencial/"
          instagram="https://www.instagram.com/utpl/"
          tiktok="https://www.tiktok.com/@utpl.ec"
        ></ConectUs>
      </div>
      <BannerGeneral></BannerGeneral>
    </>
  );
}

export default Presencial;
